import {call, put, takeEvery} from 'redux-saga/effects';
import {PayloadAction} from "@reduxjs/toolkit";
import {api} from "../../api/api";
import {cardsActions} from "../cards.slice";
import {CardGenerationStateDto} from "../../common";

// Like regenerate, only starts the background generation.
function* invertSaga(action: PayloadAction<string>) {
    const cardId = action.payload;

    try {
        const started: CardGenerationStateDto = yield call(api.invertCard, {cardId});
        yield put(cardsActions.setGeneration({cardId, generation: started.generation}));
    } catch (error) {
        window.alert(error instanceof Error ? error.message : 'Failed to invert card');
    }
}

export function* invertCardSaga() {
    yield takeEvery(cardsActions.invertCard.type, invertSaga);
}
